module.exports = __webpack_public_path__ + "img/exchange-alt-solid.fb702754.svg";